import { render, staticRenderFns } from "./AttributionsClient.vue?vue&type=template&id=b5e1765e"
import script from "./AttributionsClient.vue?vue&type=script&lang=js"
export * from "./AttributionsClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports